import { Component, OnInit , AfterViewInit } from '@angular/core';
import { SouscripteurServiceClient } from '../services/souscripteur.service';
import { Souscripteur } from '../models/souscripteur.model';
import { Paiement } from '../models/paiement.model';
import { Contrat } from '../models/contrat.model';
import { Beneficiaire } from '../models/beneficiaire.model';
import { CheckTokenService } from '../../common/services/check-token.service';
import { AuthorizationService } from '../../common/services/authorization.service';
import { TokenStorage } from '../../core/token.storage';



@Component({
  selector: 'main-component',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']

})
export class MainComponent implements OnInit {
  
  public souscripteur: Souscripteur;
  public paiements: Paiement[];
  beneficiaires: Beneficiaire[];
  contrats: Contrat[];

  constructor(private authorizationService: AuthorizationService, private token: TokenStorage, private checkTokenService: CheckTokenService, private souscripteurServiceClient: SouscripteurServiceClient) {
         this.authorizationService.isAdmin();

    this.getData();
        
  }

  getData(){
    this.souscripteurServiceClient.getSouscripteur(this.token.getLogin()).subscribe(
      data => {
        ///console.log("Data: " + data.id + "Nom: " + data.firstName + "Prenom: " + data.lastName);
          this.souscripteur = data;
          this.contrats = this.souscripteur.contrats;
          this.beneficiaires = this.contrats[0].beneficiaire;
          this.paiements = this.contrats[0].paiement
          
          ///console.log( this.souscripteur);
          
      }); 


  }

  ngOnInit() {
    this.checkTokenService.verifyToken();

  }
   
}



// WEBPACK FOOTER //
// ./src/app/client-app/main/main.component.ts